<template>
  <div class="base-input">
    <div v-if="label" class="base-input__label"> {{ label }} </div>
    <div class="base-input__block">
      <div v-if="placeholderUp" class="base-input__block__label"> {{ placeholder }} </div>
      <input class="base-input__block__value"
          v-bind="$attrs"
          :type="type"
          :value="value"
          :required="required"
          :placeholder="getPlaceholder"
          @blur="placeholderUp = false"
          @focus="placeholderUp = true"
          @input="$emit('input', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  props: {
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      placeholderUp: false
    }
  },
  computed: {
    getPlaceholder() {
      return !this.placeholderUp ? this.placeholder : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.base-input {

  &__label {
    font-weight: 700;
    font-size: 19px;
    color: black;
    text-align: left;
    margin-bottom: 10px;
  }

  &__block {
    position: relative;

    &__label {
      font-size: 14px;
      font-weight: 600;
      text-align: left;
      position: absolute;
      left: 1rem;
      top: -0.5rem;
      z-index: 0;
      background: #F4F7F8;
      padding: 0 0.125rem;
    }

    &__value {
      height: 2.4rem;
      width: calc(100% - 40px);
      border: black solid 1px;
      border-radius: 8px;
      padding: 0 16px;
      font-size: 18px;
      background: #F4F7F8;
    }
  }
}

</style>